<template>
<div>
    <Breadcrumbs main="Admin" submain="Portfolio" title="Experiences" />
    <!-- Container-fluid starts-->
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header">
                        <button class="btn btn-primary" type="submit" v-b-modal.modal-prevent-closing style="display: flex; gap: 12px; align-items: center;">
                            <i class="fa fa-light fa-plus"></i>
                            <h7>Add Experience</h7>
                        </button>
                    </div>

                    <div class="card-body">
                        <b-row>
                            <b-col xl="6">
                                <b-input-group class="datatable-btn">
                                    <b-form-input v-model="filter" placeholder="Type to Search"></b-form-input>
                                    <b-input-group-append>
                                        <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                                    </b-input-group-append>
                                </b-input-group>
                            </b-col>

                            <b-col xl="6">
                                <b-form-group label-cols="2" label="Per page" class="mb-0 datatable-select">
                                    <b-form-select v-model="perPage" :options="pageOptions"></b-form-select>
                                </b-form-group>
                            </b-col>
                        </b-row>

                        <div v-if="!loading && !error">
                            <div class="table-responsive datatable-vue">
                                <b-table show-empty stacked="md" :items="experience_list" :fields="tablefields" :filter="filter" :current-page="currentPage" :per-page="perPage" @filtered="onFiltered">
                                    <template #cell(index)="data">
                                        {{ (currentPage - 1) * perPage + data.index + 1 }}
                                    </template>

                                    <template #cell(image)="row">
                                        <img :src="host + row.item.image" alt="" style="width: 120px; height: 80px;">
                                    </template>

                                    <template #cell(organization)="row">
                                        <div v-if="row.item.organization" style="max-width: 450px;">
                                            <p>{{ row.item.organization }}</p>
                                        </div>
                                    </template>

                                    <template #cell(source)="row">
                                        <div v-if="row.item.source">
                                            <p>{{ row.item.source }}</p>
                                        </div>
                                    </template>

                                    <template #cell(date)="row">
                                        <div v-if="row.item.start_date && row.item.end_date">
                                            <p>{{ row.item.start_date }} - {{ row.item.end_date }}</p>
                                            
                                        </div>
                                    </template>

                                    <!-- <template #cell(link)="row">
                                                <div v-if="row.item.link">
                                                    <a :href="row.item.link" target="_blank" class="link-style">{{ row.item.link.substring(0,40) }}</a>
                                                </div>
                                                <div v-else>
                                                    N/A
                                                </div>
                                            </template> -->

                                    <template #cell(action)="data">
                                        <span style="display: flex; gap: 12px;">
                                            <div>
                                                <feather type="delete" size="22px" style="color: #ff595d; cursor: pointer;" v-b-tooltip.hover v-b-modal.modal-center @click="deleteExperiences(data.item.id)" title="Delete"></feather>
                                            </div>
                                            <div @click="editExperiences(data.item)">
                                                <feather type="edit" size="20px" style="color: #568ae3; cursor: pointer;" v-b-tooltip.hover title="Edit" v-b-modal.modal-prevent-closing-edit></feather>
                                            </div>
                                        </span>
                                    </template>
                                </b-table>
                            </div>
                        </div>

                        <div v-else>
                            <loader />
                        </div>

                        <b-col md="6" class="my-1 p-0">
                            <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage" class="my-0"></b-pagination>
                        </b-col>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- Container-fluid Ends-->

    <!-- Experiences Create Modal -->
    <b-modal id="modal-prevent-closing" ref="modal" title="Add Experience" size="xl" @show="resetModal" @hidden="resetModal" @ok="handleOk">
        <form ref="form" @submit.stop.prevent="handleSubmit()">
            <div class="row">
                <div class="col-sm-6">
                    <div class="form-group">
                        <label>Title</label>
                        <input class="form-control" type="text" placeholder="Enter Title" v-model="experience.title">
                    </div>
                </div>
                <div class="col-sm-6">
                    <div class="form-group">
                        <label>Organization</label>
                        <input class="form-control" type="text" placeholder="Enter Oraganization" v-model="experience.organization">
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-md-6">
                    <div class="form-group">
                        <label>Start Date</label>
                        <input class="form-control" type="text" placeholder="Enter Start Date" v-model="experience.start_date">
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="form-group">
                        <label>End Date</label>
                        <input class="form-control" type="text" placeholder="Enter End Date" v-model="experience.end_date">
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-sm-6">
                    <div class="form-group">
                        <label>Location</label>
                        <input class="form-control" type="text" placeholder="Enter Location" v-model="experience.location">
                    </div>
                </div>
            </div>

        </form>
    </b-modal>

    <!-- Experiences Edit Modal -->
    <b-modal id="modal-prevent-closing-edit" ref="modal" title="Edit Experience" size="xl" @show="resetEditModal" @hidden="resetEditModal" @ok="handleEditOk">
        <form ref="form" @submit.stop.prevent="handleEditSubmit">
            <div class="row">
                <div class="col-sm-6">
                    <div class="form-group">
                        <label>Title</label>
                        <input class="form-control" type="text" placeholder="Enter Title" v-model="edit_experience.title">
                    </div>
                </div>
                <div class="col-sm-6">
                    <div class="form-group">
                        <label>Organization</label>
                        <input class="form-control" type="text" placeholder="Enter Subject" v-model="edit_experience.organization">
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-md-6">
                    <div class="form-group">
                        <label>Start Date</label>
                        <input class="form-control" type="text" placeholder="Enter Start Date" v-model="edit_experience.start_date">
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="form-group">
                        <label>End Date</label>
                        <input class="form-control" type="text" placeholder="Enter End Date" v-model="edit_experience.end_date">
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-sm-6">
                    <div class="form-group">
                        <label>Location</label>
                        <input class="form-control" type="text" placeholder="Enter Location" v-model="edit_experience.location">
                    </div>
                </div>
            </div>
        </form>
    </b-modal>

    <!-- Gallery Delete Modal -->
    <b-modal id="modal-center" centered hide-header @ok="handleDeleteOk">
        <div class="mt-4 mb-4" style="font-size: large;">Are you sure you want to delete this experience?</div>
    </b-modal>
</div>
</template>

    
<script>
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import Datepicker from 'vuejs-datepicker';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import 'sweetalert2/src/sweetalert2.scss';
import moment from "moment";

import {
    mapState
} from 'vuex';
import loader from '../loader/loader.vue';
import {
    VueEditor
} from "vue2-editor";

export default {
    components: {
        Datepicker,
        loader,
        VueEditor
    },

    data() {
        return {
            editor: ClassicEditor,

            tablefields: [{
                    key: 'index',
                    label: '#'
                },
                {
                    key: 'title',
                    label: 'Title',
                    sortable: true
                },
                {
                    key: 'organization',
                    label: 'Organization',
                    sortable: true
                },
                {
                    key: 'location',
                    label: 'Location',
                    sortable: true
                },
                {
                    key: 'date',
                    label: 'Date',
                    sortable: true
                },
                {
                    key: 'action',
                    label: 'Action',
                    sortable: false
                }
            ],

            years: Array.from({
                length: 101
            }, (v, k) => ({
                id: k + 1,
                name: (new Date().getFullYear() - k).toString()
            })),

            experience: {
                title: '',
                organization: '',
                location: '',
                start_date: '',
                end_date: '',
            },

            edit_experience: {
                id: '',
                title: '',
                organization: '',
                location: '',
                start_date: '',
                end_date: '',
            },

            delete_value: null,

            filter: null,
            totalRows: 1,
            currentPage: 1,
            perPage: 10,
            pageOptions: [5, 10, 15]
        };
    },

    computed: {
        ...mapState({
            experience_list: state => state.experience.experience,
            loading: state => state.experience.experienceLoading,
            error: state => state.experience.experienceError
        }),

        sortOptions() {

            return this.tablefields
                .filter(f => f.sortable)
                .map(f => {
                    return {
                        text: f.label,
                        value: f.key
                    };
                });
        }
    },

    mounted() {
        this.$store.dispatch("experience/fetchExperiences").then(() => {
            this.items = this.experience_list
            this.totalRows = this.items.length;
        });
    },

    methods: {

        onFiltered(filteredItems) {
            this.totalRows = filteredItems.length;
            this.currentPage = 1;
        },

        resetModal() {
            this.experience.title = null
            this.experience.organization = null
            this.experience.location = null
            this.experience.start_date = null
            this.experience.end_date = null

        },

        handleOk(bvModalEvent) {
            bvModalEvent.preventDefault()
            this.handleSubmit()
        },

        handleSubmit() {
            

            this.$store.dispatch("experience/addExperiences", {
                experience: this.experience
            }).then(response => {
                if (response.code == 200) {
                    Swal.fire({
                        title: "Success!",
                        text: response.response,
                        icon: "success"
                    });
                    this.experience.title = null
                    this.experience.organization = null
                    this.experience.location = null
                    this.experience.start_date = null
                    this.experience.end_date = null
                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    });
                }
            })

            this.$nextTick(() => {
                this.$bvModal.hide('modal-prevent-closing')
            })
        },

        editExperiences(detail) {
            this.edit_experience.id = detail.id ? detail.id : null
            this.edit_experience.title = detail.title ? detail.title : null
            this.edit_experience.organization = detail.organization ? detail.organization : null
            this.edit_experience.location = detail.location ? detail.location : null
            this.edit_experience.start_date = detail.start_date ? detail.start_date : null
            this.edit_experience.end_date = detail.end_date ? detail.end_date : null

        },

        resetEditModal() {
            this.edit_experience.title = null
            this.edit_experience.organization = null
            this.edit_experience.location = null
            this.edit_experience.start_date = null
            this.edit_experience.end_date = null
        },

        handleEditOk(bvModalEvent) {
            bvModalEvent.preventDefault()
            this.handleEditSubmit()
        },

        handleEditSubmit() {
           
            this.$store.dispatch("experience/updateExperiences", {
                id: this.edit_experience.id,
                experience: this.edit_experience,
            }).then(response => {
                if (response.code == 200) {
                    Swal.fire({
                        title: "Success!",
                        text: response.response,
                        icon: "success"
                    });
                    this.edit_experience.title = null
                    this.edit_experience.organization = null
                    this.edit_experience.location = null
                    this.edit_experience.start_date = null
                    this.edit_experience.end_date = null
                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    });
                }
            })

            this.$nextTick(() => {
                this.$bvModal.hide('modal-prevent-closing-edit')
            })
        },

        deleteExperiences(id) {
            this.delete_value = id
        },

        handleDeleteOk() {
            this.$store.dispatch("experience/deleteExperiences", {
                delete: this.delete_value
            }).then(response => {
                if (response.code == 200) {
                    Swal.fire({
                        title: "Success!",
                        text: response.response,
                        icon: "success"
                    });
                    this.delete_value = null
                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    });
                }
            })
        }
    }
};
</script>
